module.exports = __webpack_public_path__ + "static/media/20200523-163008-001.3ff76a6c.png";